/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  eqeqeq,
  import/no-extraneous-dependencies,
  no-return-assign,
  one-var,
  prefer-const,
  react/prop-types
*/
/**
    An inline menu component designed for the signer page header.
*/

import './index.scss';
import React from 'react';
import PropTypes from 'prop-types';
import delegateIconSrc from 'signer/assets/Reassign_signer_icon.svg';
import Link from 'common/components/link';
import logger from 'common/logger';
import * as embeddedActions from 'signer/actions/embedded';

import {
  FormattedMessage,
} from 'react-intl';
import CloseIconSrc from './x_dark_@2x.png';
import DownloadIconSrc from './download_icon_@2x.png';
import DeclineImageSrc from './decline_@2x.png';
import MoreImageSrc from './more_@2x.png';

export default class HeaderMenu extends React.Component {

    static propTypes = {

      /**
         * If true, the delegate menu item will be displayed
         */
      canDelegate: PropTypes.bool,
    };

    constructor(props) {
      super(props);

      this.state = {
        menuIsShown: false,
      };

      this.onPlaceholderHover = this.onPlaceholderHover.bind(this);
      this.onPlaceholderClick = this.onPlaceholderClick.bind(this);
      this.onMenuWrapperMouseOut = this.onMenuWrapperMouseOut.bind(this);
      this.onMenuClick = this.onMenuClick.bind(this);
      this.onToggleCallback = this.onToggleCallback.bind(this);
      this.decline = this.decline.bind(this);
      this.close = this.close.bind(this);
      this.delegate = this.delegate.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.confirmQualifiedSignature = this.confirmQualifiedSignature.bind(this);
    }

    componentDidMount() {
      if (typeof document !== 'undefined') {
        document.addEventListener('click', this.handleDocumentClick);
      }
    }

    componentWillUnmount() {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', this.handleDocumentClick);
      }
    }

    /**
     * Checks if the document has been clicked outside of this component and
     * closed the menu if true.
     */
    handleDocumentClick(e) {
      const node = this.node;

      // If this component node contains the node that was clicked, don't do
      // anything.
      if (node && node.contains(e.target)) {
        return;
      }

      // Otherwise, close the menu
      this.setState({ menuIsShown: false });
    }

    onPlaceholderHover() {
      // Be sure not to do this on mobile; On Chrome in touch mode, tapping
      // results in simulated hover events as well, so we end up having these
      // two handler competing and ending up in the wrong state.
      const app = this.props.app || window.app;
      if (!app.isMobile) {
        this.setState({
          menuIsShown: true,
        });
        logger.track('HeaderMenu.onPlaceholderHover');
        this.onToggleCallback(true);
      }
    }

    onPlaceholderClick() {
      const app = this.props.app || window.app;
      if (app.isMobile) {
        this.setState({
          menuIsShown: !this.state.menuIsShown,
        });
        if (this.state.menuIsShown) {
          logger.track('HeaderMenu.onPlaceholderClick');
        }
        this.onToggleCallback(!this.state.menuIsShown);
      }
    }

    onMenuWrapperMouseOut() {
      this.setState({
        menuIsShown: false,
      });
      this.onToggleCallback(false);
    }

    onMenuClick() {
      this.setState({
        menuIsShown: false,
      });
      this.onToggleCallback(false);
    }

    onToggleCallback(isShown) {
      if (typeof this.props.onMenuToggle === 'function') {
        this.props.onMenuToggle(isShown);
      }
    }

    decline() {
      this.props.app.router.displayFullScreenModal('confirmDecline');
    }

    close() {
      embeddedActions.closeWindow(this.props.app);
    }

    delegate() {
      logger.track('Reassign.HeaderMenu.onClick');
      this.props.app.router.displayFullScreenModal('confirmDelegate');
    }

    confirmQualifiedSignature() {
      this.props.app.router.displayFullScreenModal('confirmQualifiedSignature');
    }

    renderDivider(keyindex) {
      const key = `divider-${keyindex}`;
      return (<div key={key} className='divider'></div>);
    }

    render() {

      const app = this.props.app;
      const canDownload = app.canDownload();
      const canClose = app.canCancel();
      const canDecline = app.canDecline();
      const canDelegate = this.props.canDelegate;

      // Setup menu items
      const menuItems = [];
      let declineItem,
        downloadItem,
        closeItem,
        delegateItem;
      declineItem = (
        <div key='decline' data-qa-ref='decline' className='menu-item decline' onClick={this.decline}>
          <div className='item-image'>
            <img src={DeclineImageSrc} />
          </div>
          <FormattedMessage
            id="signer.headerMenu.decline"
            description="link text in signer flow, it is for singer to decline the signature request"
            defaultMessage="Decline" />
        </div>
      );
      const downloadLink = app.signatureRequest.getDownloadLink();
      downloadItem = (
        <Link key='download' className='menu-item download' href={downloadLink}>
          <div className='item-image'>
            <img src={DownloadIconSrc} />
          </div>
          <FormattedMessage
            id="signer.headerMenu.download"
            description="link text in signer flow, downloads the signature request document"
            defaultMessage="Download" />
        </Link>
      );
      closeItem = (
        <div key='close' className='menu-item close' onClick={this.close}>
          <div className='item-image'>
            <img src={CloseIconSrc} />
          </div>
          <FormattedMessage
            id="signer.headerMenu.close"
            description="link text in signer flow, closes the signer flow for signer"
            defaultMessage="Close" />
        </div>
      );
      delegateItem = (
        <div key='delegate' className='menu-item delegate' onClick={this.delegate} data-test-ref='delegate-cta'>
          <div className='item-image'>
            <img src={delegateIconSrc} />
          </div>
          <FormattedMessage
            id="signer.headerMenu.delegate"
            description="link text in signer flow for signer to request another user to sign instead"
            defaultMessage="Reassign" />
        </div>
      );


      // Add relevant Menu Items and dividers
      if (canDelegate) {
        menuItems.push(delegateItem);
      }
      if (canDecline) {
        if (canDelegate) menuItems.push(this.renderDivider(1));
        menuItems.push(declineItem);
      }
      if (canDownload) {
        if (canDecline) menuItems.push(this.renderDivider(2));
        menuItems.push(downloadItem);
      }
      if (canClose) {
        if (canDecline || canDownload) menuItems.push(this.renderDivider(3));
        menuItems.push(closeItem);
      }

      if (menuItems.length == 0) {
        return null;
      }

      let menu;
      if (this.state.menuIsShown) {
        menu = (
          <div className='menu-wrapper'
            data-test-ref='menu'
            onMouseLeave={this.onMenuWrapperMouseOut}
          >
            <div className='menu' onClick={this.onMenuClick}>
              { menuItems }
            </div>
          </div>
        );
      }

      return (
        <div className='m-signer-header-menu'
          data-qa-ref='menu-toggle'
          data-test-ref='menu-toggle'
          ref={(node) => this.node = node}
          onMouseOver={this.onPlaceholderHover}
          onClick={this.onPlaceholderClick}
        >
          <img className='more-image' src={MoreImageSrc} />
          { menu }
        </div>
      );
    }
}
